import React from 'react';
import './TransactionMetricCard.css';

interface TransactionMetricCardProps {
  title: string;
  value: string;
  color?: 'default' | 'green' | 'red';
  icon?: string;
}

const TransactionMetricCard: React.FC<TransactionMetricCardProps> = ({
  title,
  value,
  color = 'default',
  icon,
}) => {
  return (
    <div className={`transaction-metric-card metric-${color}`}>
      <div className="transaction-metric-header">
        <h3 className="transaction-metric-title">{title}</h3>
        {icon && (
          <div className={`transaction-metric-icon icon-${color}`}>
            {icon}
          </div>
        )}
      </div>
      <div className={`transaction-metric-value value-${color}`}>{value}</div>
    </div>
  );
};

export default TransactionMetricCard;

